import { BottomAction } from '@euler/app/components/BottomAction';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { WiredTaskDetailPageContainer } from '@euler/app/flows/task/pages/detail/components/DetailPageContainer';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CommonTaskStatus } from '@euler/model/enum';
import { memo } from 'react';
import { StyleProp, useWindowDimensions, View, ViewStyle } from 'react-native';
import { useSharedValue } from 'react-native-reanimated';
import { useFacadeInspection } from '../functions/useFacadeInspection';
import { usePreInspectionActions } from '../functions/usePreInspectionActions';
import { WiredDashboardInspection } from './DashboardInspection';
import { FacadeMediaList } from './FacadeInspectionMediaListView';
import { FacadeSitesView } from './FacadeSitesView';
import { WiredPreInspectionSignature } from './PreInspectionSignature';

export const WiredPreInspectionScreenContent = memo(() => {
  const scrollY = useSharedValue(0);
  const { width } = useWindowDimensions();
  const { rpx } = useResponsiveContext();
  const contentWidth = width;
  const { detail } = useTaskContext();
  const { onViewReport, showActions } = usePreInspectionActions({
    strict: true,
  });

  return (
    <>
      <WiredTaskDetailPageContainer
        title="车辆预检"
        scrollY={scrollY}
        onShowActions={
          detail.preInspection.status === CommonTaskStatus.InProgress
            ? showActions
            : undefined
        }
        contentContainerStyle={{
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 0,
        }}
        css={`
          flex: 1;
          background: white;
        `}
      >
        <WiredDashboardInspection
          width={contentWidth}
          height={contentWidth * (6 / 9)}
          imageContainerStyle={{ paddingLeft: rpx(15), paddingRight: rpx(15) }}
        />

        <WiredFacadeInspection width={contentWidth} />

        <WiredPreInspectionSignature
          css={`
            padding-bottom: ${rpx(105)}px;
          `}
        />
      </WiredTaskDetailPageContainer>

      <BottomAction scrollY={scrollY}>
        <BottomAction.Button text="预览报告" onPress={onViewReport} />
      </BottomAction>
    </>
  );
});

const WiredFacadeInspection = memo(
  ({ width, style }: { width: number; style?: StyleProp<ViewStyle> }) => {
    const {
      medias,
      facadeSites,
      siteInspections,
      requiredSites,
      frontRecordCount,
      rearRecordCount,
      onSitePress,
      onDeleteMedia,
      onRetryMediaUpload,
      onPreviewVideo,
    } = useFacadeInspection();
    const { rpx } = useResponsiveContext();
    return (
      <View style={style}>
        <FacadeSitesView
          facadeSites={facadeSites}
          siteInspections={siteInspections}
          requiredSites={requiredSites}
          frontRecordCount={frontRecordCount}
          rearRecordCount={rearRecordCount}
          contentWidth={width - rpx(30)}
          onSitePress={onSitePress}
          css={`
            margin-top: ${rpx(15)}px;
            padding-left: ${rpx(15)}px;
            padding-right: ${rpx(15)}px;
          `}
        />
        <FacadeMediaList
          medias={medias}
          width={width}
          numColumns={4}
          scrollEnabled={false}
          onDelete={onDeleteMedia}
          onPreviewVideo={onPreviewVideo}
          onRetryUpload={onRetryMediaUpload}
          contentContainerStyle={{
            paddingVertical: rpx(15),
            paddingHorizontal: rpx(10),
          }}
        />
      </View>
    );
  },
);
